module.exports = __webpack_public_path__ + "static/media/client-list.383adbf7.jpg";